// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Development Ribbon
========================================================================== */
.ribbon {
  background-color: rgba(170, 0, 0, 0.5);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: absolute;
  top: 40px;
  white-space: nowrap;
  width: 15em;
  z-index: 99999;
  pointer-events: none;
  opacity: 0.75;
}
.ribbon a {
  color: #fff;
  display: block;
  font-weight: 400;
  margin: 1px 0;
  padding: 10px 50px;
  text-align: center;
  text-decoration: none;
  text-shadow: 0 0 5px #444;
  pointer-events: none;
}

/* ==========================================================================
Navbar styles
========================================================================== */
.jh-navbar {
  background-color: #353d47;
  padding: 0.2em 1em;
}
.jh-navbar .profile-image {
  margin: -10px 0;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
.jh-navbar .dropdown-item.active,
.jh-navbar .dropdown-item.active:focus,
.jh-navbar .dropdown-item.active:hover {
  background-color: #353d47;
}
.jh-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}
.jh-navbar .navbar-nav {
  padding: 0.5em;
}
.jh-navbar .navbar-nav .nav-item {
  margin-left: 1.5rem;
}
.jh-navbar a.nav-link {
  font-weight: 400;
}
.jh-navbar a.nav-link > span {
  margin-left: 5px;
}
.jh-navbar .jh-navbar-toggler {
  color: #ccc;
  font-size: 1.5em;
  padding: 10px;
}
.jh-navbar .jh-navbar-toggler:hover {
  color: #fff;
}

.navbar-brand {
  overflow: hidden;
}

.jh-navbar .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-version {
  font-size: 0.65em;
  color: #bbb;
  padding: 0 0 0 10px;
}

.brand-logo:hover {
  text-decoration: none;
}
.brand-logo .brand-icon {
  height: 35px;
  width: auto;
  display: inline-block;
}
.brand-logo .brand-icon img {
  width: 45px;
}

.brand-title {
  font-size: 1.25rem;
  margin-left: 0.25rem;
  color: #fff;
}
.brand-title:hover {
  color: #cccccc;
  text-decoration: none;
}

.loading-bar {
  height: 3px;
  z-index: 1031;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss"],"names":[],"mappings":"AAIA;;4EAAA;AAGA;EACE,sCAAA;EACA,YAAA;EAKA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;AAHF;AAIE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AAFJ;;AAMA;;4EAAA;AAGA;EACE,yBAAA;EACA,kBAAA;AAHF;AAIE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAIE;;;EAGE,yBAAA;AAFJ;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,cAAA;AAFJ;AAGI;EACE,mBAAA;AADN;AAIE;EACE,gBAAA;AAFJ;AAGI;EACE,gBAAA;AADN;AAIE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AAFJ;AAGI;EACE,WAAA;AADN;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,iBAAA;EACA,WAvFuB;EAwFvB,mBAAA;AAFF;;AAME;EACE,qBAAA;AAHJ;AAKE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AAHJ;AAII;EACE,WAAA;AAFN;;AAOA;EACE,kBAAA;EACA,oBAAA;EACA,WA7Ga;AAyGf;AAKE;EACE,cA7GiB;EA8GjB,qBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,aAAA;AAJF","sourcesContent":["$header-color: #fff;\n$header-color-secondary: #bbb;\n$header-color-hover: darken($header-color, 20%);\n\n/* ==========================================================================\nDevelopment Ribbon\n========================================================================== */\n.ribbon {\n  background-color: rgba(170, 0, 0, 0.5);\n  left: -3.5em;\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  overflow: hidden;\n  position: absolute;\n  top: 40px;\n  white-space: nowrap;\n  width: 15em;\n  z-index: 99999;\n  pointer-events: none;\n  opacity: 0.75;\n  a {\n    color: #fff;\n    display: block;\n    font-weight: 400;\n    margin: 1px 0;\n    padding: 10px 50px;\n    text-align: center;\n    text-decoration: none;\n    text-shadow: 0 0 5px #444;\n    pointer-events: none;\n  }\n}\n\n/* ==========================================================================\nNavbar styles\n========================================================================== */\n.jh-navbar {\n  background-color: #353d47;\n  padding: 0.2em 1em;\n  .profile-image {\n    margin: -10px 0;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n  }\n  .dropdown-item.active,\n  .dropdown-item.active:focus,\n  .dropdown-item.active:hover {\n    background-color: #353d47;\n  }\n  .dropdown-toggle::after {\n    margin-left: 0.15em;\n  }\n  .navbar-nav {\n    padding: 0.5em;\n    .nav-item {\n      margin-left: 1.5rem;\n    }\n  }\n  a.nav-link {\n    font-weight: 400;\n    > span {\n      margin-left: 5px;\n    }\n  }\n  .jh-navbar-toggler {\n    color: #ccc;\n    font-size: 1.5em;\n    padding: 10px;\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n.navbar-brand {\n  overflow: hidden;\n}\n\n.jh-navbar .navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-version {\n  font-size: 0.65em;\n  color: $header-color-secondary;\n  padding: 0 0 0 10px;\n}\n\n.brand-logo {\n  &:hover {\n    text-decoration: none;\n  }\n  .brand-icon {\n    height: 35px;\n    width: auto;\n    display: inline-block;\n    img {\n      width: 45px;\n    }\n  }\n}\n\n.brand-title {\n  font-size: 1.25rem;\n  margin-left: 0.25rem;\n  color: $header-color;\n  &:hover {\n    color: $header-color-hover;\n    text-decoration: none;\n  }\n}\n\n.loading-bar {\n  height: 3px;\n  z-index: 1031;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
